// Get the top position of an element in the document
function getTop(element, start) {
  return element.getBoundingClientRect().top + start
}

function easeInOutCubic(t) {
  return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
}

// calculate the scroll position we should be in given the start and end point of the scroll
// the time elapsed from the beginning of the scroll and the total duration of the scroll (default 500ms)
function position(start, end, elapsed, duration) {
  if (elapsed > duration) return end;
  return start + (end - start) * easeInOutCubic(elapsed / duration); // <-- you can change the easing funtion there
  // return start + (end - start) * (elapsed / duration); // <-- this would give a linear scroll
}

// we use requestAnimationFrame to be called by the browser before every repaint
// if the first argument is an element then scroll to the top of this element
// if the first argument is numeric then scroll to this location
// if context is set then scroll that element, else scroll window
// if the callback exist, it is called when the scrolling is finished
export function smoothScroll(el, duration, context, callback) {
  duration = duration || 500;
  let start = context.scrollTop;
  let end;
  if (typeof el === 'number') {
    end = parseInt(el);
  } else {
    end = getTop(el, start);
  }
  let clock = Date.now();
  let step = function () {
    let elapsed = Date.now() - clock;
    if (context !== window) {
      context.scrollTop = position(start, end, elapsed, duration);
    } else {
      window.scroll(0, position(start, end, elapsed, duration));
    }
    if (elapsed > duration) {
      if (typeof callback === 'function') {
        callback(el);
      }
    } else {
      window.requestAnimationFrame(step);
    }
  }
  step();
}
